import {SocialIcons} from 'Shared/frontend/footer/SocialIcons';
import {For, Switch} from 'solid-js'
import {Phone} from 'Shared/frontend/icons/Phone';
import {Pin} from 'Shared/frontend/icons/Pin';
import {Show} from 'solid-js';
import { css, cx } from '@emotion/css';
import {displayState} from 'Shared/frontend/displayState';
import { fluidType } from 'Shared/common/FluidType';
import { sizes,palette, theme, useSettings } from 'Shared/frontend/SettingsProvider';
import { useUrls } from 'Shared/SiteProvider';
//TODO look at sharing issue wrt leadingIconStyle only. Probably dont need to wrap the SVG
import { leadingIconStyle } from 'Shared/frontend/leadingIconStyle';
import { isActive, navItemLink } from 'Shared/frontend/nav/MobileFooterNav';
import { Match } from 'solid-js';


const overlayStyle = () => css(theme().nav.mobile.more.root,{
	/* On Chrome '100vw' creates a horizontal scrollbar when a vertical scrollbar is present */
	width: '100%',
	minHeight: '100vh',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: '1em',
	paddingBottom: 100,
	justifyContent: 'center', //CJ added 
});

const logoStyle = () => css({
	width: fluidType('px',sizes().endFontShrink,sizes().flipToMobileNav,100,300),
});

const buttonStyle = () => css(theme().button, theme().nav.mobile.more.button,{
	width: '100%'
});

const activeStyle = () => css(theme().nav.mobile.active);	

const itemWithIconStyle = () => css({
	color: palette().text,
	textDecoration: 'none'
});

const addressStyle = () => css(theme().footer.address,{
	textAlign: 'center'
});
const phoneStyle = () => css(theme().footer.address.phone);


export function NavMore(P)
{
	const url = () => {
		if (!P.venue.logo?.hash) return '';
		return useUrls().createImageUrl(P.venue.logo.hash,P.venue.logo,'Venue-logo','full');
	};

	return (
		<div class={overlayStyle()}>
			<img class={logoStyle()} src={url()} /> 

			<nav>
				<Contents closeOverlay={P.closeOverlay} />
			</nav>

			<ThirdPartyServices links={P.venue.thirdPartyService} venue={P.venue} />
			<PhoneAndAddress venue={P.venue}/>
			 <SocialIcons venue={P.venue}/>
		</div>
	);
}

function Contents(P)
{
	return (
		<For each={useSettings().navContent().desktop}>{ item =>
			<Switch>
				<Match when={item.items}>
					{/* The More button items: */}
					<For each={item.items}>{ subItem =>
						<Item item={subItem} closeOverlay={P.closeOverlay} />
					}</For>
				</Match>
				<Match when={true}>
					<Item item={item} closeOverlay={P.closeOverlay} />
				</Match>
			</Switch>
		}</For>
	);
}

function Item(P)
{
	return (
		<a href={navItemLink(P.item)}>
			<button 
				tabindex='-1' 
				class={cx(buttonStyle(), isActive(P.item) && activeStyle())}
				onClick={() => P.closeOverlay()}
			>
				{P.item.label}
			</button>
		</a>
	);
}

function PhoneAndAddress(P)
{
	return (
		<>
			<Show when={P.venue.phoneNumber}>
				<a class={itemWithIconStyle()} href={'tel:'+P.venue.phoneNumber}>
					<div class={leadingIconStyle()}>
						<Phone />  
					</div>
					{' '}

					<span class={phoneStyle()}>
						{P.venue.phoneNumber}
					</span>
				</a>
			</Show>

			 <a class={itemWithIconStyle()} href={P.venue.mapUrl} target='_blank'>
				<div class={leadingIconStyle()}>
					<Pin /> 
				</div>

				<address class={addressStyle()}>
					{P.venue.streetAddress}<br/>
					{P.venue.suburb+' '}
					{displayState(P.venue.state)+' '}
					{P.venue.postcode}
				</address>
			</a> 

			<Show when={P.venue.postalAddress}>
				<p>Postal Address: {P.venue.postalAddress}</p>
			</Show>
		</>
	);
}

function ThirdPartyServices(P)
{
	return (
		<div class='thirdPartyServices'>
			<For each={P.links}>{ service =>
				<a href={service.url} target='_blank'>
					<button>
						{ service.title != 'other' ? service.title : service.other }
					</button>
				</a>
			}</For>
		</div>
	);
}

